import React, { useState } from 'react';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import { TracPageLink } from '@services/tracpage/types/trac-page-link';

import LoadingCtrl from '@webapp/controllers/loading';
import { DecorationDropdown } from '@webapp/controllers/form/decoration-dropdown';

import InputField from '@components/form/input';
import DefaultAvatar from '@components/basics/default-avatar';

export function LinksDropdown({
  link,
  handleChange,
  handleRemove,
  className,
  isLoading,
  setOnKeyEnter,
}: {
  link: TracPageLink;
  isLoading?: boolean;
  className?: string;
  handleRemove: (order: number) => void;
  handleChange: <T extends keyof TracPageLink>(
    order: number,
    field: T,
    value: TracPageLink[T]
  ) => void;
  setOnKeyEnter?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [imgError, setImgError] = useState<boolean>(false);

  const leftDecoration = (
    <DecorationDropdown hideArrow>
      {imgError ? (
        <DefaultAvatarIcon />
      ) : (
        <Avatar
          src={link.avatar}
          alt={link.title}
          onError={() => setImgError(true)}
        />
      )}
    </DecorationDropdown>
  );
  return (
    <LinkWrapper className={className || ''}>
      <InputField
        name="title"
        locked={isLoading}
        label={
          <Translate id="ARTIST_PROFILE.PROFILE.SUBITEM.GENERAL.LINKS.INPUT.TITLE.LABEL" />
        }
        leftDecoration={leftDecoration}
        hasClose
        onClose={() => handleRemove(link.order)}
        onChange={(value) => handleChange(link.order, 'title', value)}
        onKeyDown={(event) => {
          if (event?.key === 'Enter' && setOnKeyEnter) {
            setOnKeyEnter(true);
          }
        }}
        onBlur={() => {
          if (setOnKeyEnter) setOnKeyEnter(true);
        }}
        autoComplete="off"
        value={link.title}
      />
      {isLoading && (
        <LoadingCtrl
          size="48px"
          className="loading-animation is-loading loader"
          loading
        />
      )}
    </LinkWrapper>
  );
}
export default LinksDropdown;

const Avatar = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  object-fit: cover;
`;

const DefaultAvatarIcon = styled(DefaultAvatar)`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  object-fit: cover;
`;

const LinkWrapper = styled.div`
  position: relative;
  > .loader {
    position: absolute;
    right: 0px;
    top: 0px;
  }
`;
